import {Chips} from 'platform/components';

import {makeOnChipsChange} from '../../utils/makeOnChipsChange';

export type QuickFilterChipsProps<T> = {
  quickFilters: Array<{value: string; label: string}> | undefined;
  /** Currently selected chip value(s) — computed by the host filter. */
  value: string[] | null;
  /** Filter value to restore when the chip is deselected. */
  defaultValue: T;
  setFilterValue: (value: T) => void;
  isDisabled?: boolean;
  /** Already-suffixed testid — callers pass suffixTestId('<filter>-quickFilters', props) themselves. */
  'data-testid'?: string;
};

/**
 * The quick-filter chips strip rendered above a filter's main control.
 * Renders nothing when the column defines no quick filters.
 */
export function QuickFilterChips<T>(props: QuickFilterChipsProps<T>) {
  if (!props.quickFilters || props.quickFilters.length === 0) {
    return null;
  }

  return (
    <Chips
      isDisabled={props.isDisabled}
      value={props.value}
      options={props.quickFilters}
      onChange={makeOnChipsChange(props.setFilterValue, props.defaultValue)}
      isMultiple={false}
      data-testid={props['data-testid']}
      isDeselectable
    />
  );
}
